import React from "react";
import SelectionLayer from "./SelectionLayer";

export default function GlobalLayers({ start, end }) {
	return <SelectionLayer end={end} start={start} />;
}
